<script setup>
import { Head } from '@inertiajs/vue3'
import { useI18n } from 'vue-i18n'
import PublicLayout from '@/Layouts/PublicLayout.vue'

defineOptions({ layout: PublicLayout })

const { t } = useI18n()
</script>

<template>
  <Head><title>{{ t('public.internal_error.head_title') }}</title></Head>
  <section class="page">
    <p class="page__code">500</p>
    <h1 class="page__title">{{ t('public.internal_error.title') }}</h1>
    <p class="page__lede">{{ t('public.internal_error.lede') }}</p>
    <a href="/" class="page__cta">{{ t('public.internal_error.cta_home') }}</a>
  </section>
</template>

<style scoped>
.page { max-width: 32rem; margin: 0 auto; padding: 4rem 1.5rem; text-align: center; }
.page__code { font-size: 0.75rem; font-weight: 600; letter-spacing: 0.15em; color: var(--muted); text-transform: uppercase; margin: 0 0 0.75rem; }
.page__title { font-family: var(--font-display, var(--display)); font-size: 2rem; margin: 0 0 0.5rem; color: var(--ink); font-weight: 700; }
.page__lede  { color: var(--inkSoft); margin: 0 0 2rem; }
.page__cta   { display: inline-block; padding: 0.65rem 1.25rem; border-radius: 0.625rem; background: var(--accent); color: var(--accentInk); text-decoration: none; font-weight: 600; }
</style>
